import { useLayoutEffect, useRef } from "react";

import classnames from "classnames";
import { isPresent } from "neetocist";
import PropTypes from "prop-types";

import RightBlock from "./RightBlock";

const SubHeader = ({
  className = "",
  leftActionBlock,
  rightActionBlock,
  "data-testid": dataTestid = "subheader",
}) => {
  const subheaderRef = useRef(null);

  useLayoutEffect(() => {
    const updateHeaderHeight = () => {
      if (!subheaderRef.current) return;
      const height = subheaderRef.current.offsetHeight;
      document.body.style.setProperty("--nv-subheader-height", `${height}px`);
    };

    updateHeaderHeight();

    window.addEventListener("resize", updateHeaderHeight);

    return () => {
      window.removeEventListener("resize", updateHeaderHeight);
      document.body.style.removeProperty("--nv-subheader-height");
    };
  }, []);

  return (
    <div
      data-testid={isPresent(dataTestid) ? dataTestid : "subheader"}
      ref={subheaderRef}
      className={classnames(
        "mb-5 flex w-full shrink-0 flex-row flex-wrap items-center justify-between gap-4 md:flex-nowrap",
        className
      )}
    >
      <div className="flex grow" data-testid="subheader-left-wrapper">
        {leftActionBlock && (
          <div
            className="flex flex-row items-center justify-start"
            data-testid="subheader-left"
          >
            {leftActionBlock}
          </div>
        )}
      </div>
      {rightActionBlock && (
        <div
          className="ms-auto flex flex-row items-center justify-end gap-3 md:ms-0"
          data-testid="subheader-right"
        >
          {rightActionBlock}
        </div>
      )}
    </div>
  );
};

SubHeader.RightBlock = RightBlock;

SubHeader.propTypes = {
  /**
   * To specify external classnames as overrides to the `SubHeader`.
   */
  className: PropTypes.string,
  /**
   * To specify the content to be rendered in the left side of the `SubHeader` section.
   */
  leftActionBlock: PropTypes.node,
  /**
   * To specify the content to be rendered in the right side of the `SubHeader` section.
   */
  rightActionBlock: PropTypes.node,
};

export default SubHeader;
